import React from "react";
import {createRoot} from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import AuthProviderWithHistory from "./AuthProviderWithHistory";

const container = document.getElementById("root");

// create a root
const root = createRoot(container);

//render app to root
root.render(
  <BrowserRouter>
    <AuthProviderWithHistory>
      <App />
    </AuthProviderWithHistory>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
